export function scrollToFirstMatch(selector) {
	var elements = document.querySelectorAll(selector);
	if (elements.length > 0) {
		elements[0].scrollIntoView({ block: "start", inline: "nearest" });
	}
}